import React from 'react'    
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { ShowController, ReferenceField, TextField } from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import moment from 'moment'


const tableStyle = {
    margin: "auto",  
    width:"100%" ,  
    borderCollapse:"collapse",
    padding: "0",
    textAlign: "left",
    fontSize: "9px",
  };

  const tableStyleCenter = {
    margin: "auto",  
    width:"100%" ,  
    borderCollapse:"collapse",
    padding: "0",
    textAlign: "center",
    fontSize: "9px"
  };

const outerTable = {
    margin: "20px 10px 2px 20px",   
    borderCollapse:"collapse",
    padding: "0",
    width: "780px",

  };

const QAview=({record})=>{
    
    return(
    <div>
        <Card style={{  margin: 'auto'}}>
                    <CardContent>
                        <Grid container spacing={16}>
                            <Grid item xs={12}>
                                <Typography variant="subheading" gutterBottom style={{color: 'blue'}}>
                                    {record.name}      {record.gender}
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid container spacing={16}>
                            <Grid item xs={12}>
                                <Typography
                                    variant="body1"
                                    gutterBottom
                                    align="left"
                                >
                                <b>Amount:</b> ${record.amount}  |  <b>Volume:</b> {record.volume}  |   <b>Pay mode:</b> {record.payment_mode}
                                </Typography>
                                <Typography
                                    variant="body1"
                                    gutterBottom
                                    align="left"
                                >
                                <b>Packing case#:</b> {record.case_no}    |    <b>Packing date:</b> {record.packing_date? moment(record.packing_date).format('MM/DD/YYYY'):'     ' } | <b>UCN:</b> {record.ucn}
                                </Typography>  
                                <Typography
                                    variant="body1"
                                    gutterBottom
                                    align="left"
                                >
                                <b>SSN:</b> {record.ssn}    |    <b>Bleeding date:</b> {record.bleed_date? moment(record.bleed_date).format('MM/DD/YYYY'):'' } 
                                </Typography>  
                               
                            </Grid>
                        </Grid>
                    </CardContent>
               
                    <Table  size="xx-small" style={{ margin: 'auto' }} >
                    <TableHead style={{backgroundColor: 'grey', color: 'white'}}>
                    <TableRow>
                        <TableCell style={{color: 'white'}} align="center">HBS</TableCell>
                        <TableCell style={{color: 'white'}} align="center">HCV</TableCell>
                        <TableCell style={{color: 'white'}} align="center">HIV</TableCell>
                        <TableCell style={{color: 'white'}} align="center">HAV NAT</TableCell>
                        <TableCell style={{color: 'white'}} align="center">HBV NAT</TableCell>
                        <TableCell style={{color: 'white'}} align="center">HCV NAT</TableCell>
                    </TableRow>
                    </TableHead>
                    <TableBody>                 
                        <TableRow >
                        <TableCell align="center">{record.hbs}</TableCell>
                        <TableCell align="center">{record.hcv}</TableCell>
                        <TableCell align="center">{record.hiv}</TableCell>
                        <TableCell align="center">{record.hav_nat}</TableCell>
                        <TableCell align="center">{record.hbv_nat}</TableCell>
                        <TableCell align="center">{record.hcv_nat}</TableCell>                       
                        </TableRow>
                    </TableBody>
                    <TableHead style={{backgroundColor: 'grey', color: 'white'}}>
                    <TableRow>
                        <TableCell style={{color: 'white'}} align="center">HIV NAT</TableCell>                      
                        <TableCell style={{color: 'white'}} align="center">PARVO NAT</TableCell>
                        <TableCell style={{color: 'white'}} align="center">SPE</TableCell>
                        <TableCell style={{color: 'white'}} align="center">RPR</TableCell>
                        <TableCell style={{color: 'white'}} align="center">ABY</TableCell>
                        <TableCell style={{color: 'white'}} align="center"></TableCell>
                    </TableRow>
                    </TableHead>
                    <TableBody>                 
                        <TableRow >                       
                        <TableCell align="center">{record.hiv_nat}</TableCell>
                        <TableCell align="center">{record.parvo_nat}</TableCell>
                        <TableCell align="center">{record.spe}</TableCell>
                        <TableCell align="center">{record.rpr}</TableCell>
                        <TableCell align="center">{record.aby}</TableCell>
                        <TableCell align="center"></TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
              </Card>
    </div>
    )
}

export default QAview;

